import { isString } from 'lodash'

import { GROUP_SUPERADMIN, GROUP_MUSEUM } from '../const'

export const validations = {
  email: 'required|email',
  address: 'required',
  firstname: 'required|string|minLen:1',
  surname: 'required|string|minLen:1',
  identification: {
    login: 'required|string|minLen:3|isUniqueLogin',
    password: 'hasValidPassword',
  },
  districtId: 'hasDistrict',
  museum: 'hasMuseumName',
  group: 'hasGroup'
}

export const additionalValidators = {

  hasGroup(val, all, Validation) {
    if (all.id) {
      return true
    }
    const errors = Validation.validationErrors('number|min:1|max:3', val, all)
    return !errors
  },

  hasValidPassword(val, all, Validation) {
    if (all.id && !val) {
      return true
    }

    const confirm = all.identification.passwordConfirm
    const errors = Validation.validationErrors(
      `string|minLen:8|is:${confirm}`,
      val,
      all
    )

    return !errors
  },

  hasDistrict(val, all, Validation) {
    // group = Anything but SUPERADMIN
    if (all && all.group * 1 !== GROUP_SUPERADMIN) {
      const errors = Validation.validationErrors(
        'required',
        val,
        all
      )
      return !errors
    }
    return true
  },

  hasMuseumName(val, all, Validation) {

    // group === MUSEUM
    if (all && all.group * 1 === GROUP_MUSEUM) {

      const museumName = isString(val) ? val : val.name
      const errors = Validation.validationErrors(
        'required|string|minLen:1',
        museumName,
        all
      )

      return !errors
    }

    return true
  }
}

export const validationTexts = {
  hasGroup: () => 'Eine Gruppe muss ausgewählt sein.',
  hasValidPassword: () => 'Das Passwort muss mindestens 8 Zeichen lang sein und dem des Bestätigungsfeldes entsprechen.',
  hasDistrict: () => 'Ein Bezirk muss ausgewählt sein.',
  hasMuseumName: () => 'Museumsname muss gepflegt werden.'
}



// WEBPACK FOOTER //
// ./src/user/helpers.js